import { GradesListPageContent } from "@app/grades/pages";
import { getGradesListService } from "@core/grades/services";
import { GradeWithLessons } from "@core/grades/types";
import { getRootSettings, pageHead } from "@framework/config/drivers/meta";
import { MetaFunction } from "@remix-run/node";
import { publicRoutes } from "@framework/middleware";
import { trans } from "@mongez/localization";
import { useLoaderData } from "@remix-run/react";

export const loader = publicRoutes(async ({ http, success }) => {
  const response = await getGradesListService(http);

  return success(response);
});

export default function GradesIndex() {
  const grades = useLoaderData<GradeWithLessons[]>();

  return <GradesListPageContent grades={grades} />;
}

export const meta: MetaFunction = ({ matches }) => {
  const settings = getRootSettings(matches);

  return pageHead({
    title: `${trans("grades.title")} - ${settings.general?.appName || ""}`,
    description: trans("grades.description"),
    image: settings.general?.logo?.url || "",
    settings,
  });
};
